import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { IInstantPayAvailability } from 'src/modules/talent-dashboard/interfaces/instant-pay.interface';

@Component({
  selector: 'app-payment-timer',
  templateUrl: './payment-timer.component.html',
  styleUrls: ['./payment-timer.component.scss'],
})
export class PaymentTimerComponent implements OnInit {

@Input() instantPayAvailability: IInstantPayAvailability;

  timeRemainingSeconds: number = 0;
  timeDetails: {
    days: string;
    hours: string;
    minutes: string;
  } | null = null;

  private timerSubscription: Subscription;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    if (this.instantPayAvailability && !this.instantPayAvailability.isAvailable) {
      this.timeRemainingSeconds = this.instantPayAvailability.timeRemainingSeconds;
      this.updateFormattedTime();
      this.startTimer();
    }
  }

  startTimer() {
    // Clear existing timer if any
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    // Only start timer if there's time remaining
    if (this.timeRemainingSeconds > 0) {
      this.timerSubscription = interval(1000).subscribe(() => {
        if (this.timeRemainingSeconds > 0) {
          this.timeRemainingSeconds--;
          this.updateFormattedTime();
          this.cdr.detectChanges();
        } else {
          // Timer reached zero
          this.timerSubscription.unsubscribe();
          this.timeDetails = null;
        }
      });
    }
  }

  updateFormattedTime() {
    if (this.timeRemainingSeconds <= 0) {
      this.timeDetails = null;
      return;
    }

    const days = Math.floor(this.timeRemainingSeconds / 86400);
    const hours = Math.floor((this.timeRemainingSeconds % 86400) / 3600);
    const minutes = Math.floor((this.timeRemainingSeconds % 3600) / 60);

    this.timeDetails = {
      days: days.toString().padStart(2, '0'),
      hours: hours.toString().padStart(2, '0'),
      minutes: minutes.toString().padStart(2, '0')
    };
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
}
